import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import services from '../../services';
import { FiLayout, FiTrash2, FiUsers, FiChevronRight } from 'react-icons/fi';
import { toast } from 'react-toastify';
import DeletePopup from '../DeletePopup';
import PageHeader from '../../common/PageHeader';

/* ── style tokens ── */
const s = {
    pageWrapper: {
        padding: '24px 28px',
        minHeight: '100vh',
        background: '#f8fafb',
    },

    /* ── Board list ── */
    listCard: {
        background: '#fff',
        borderRadius: '16px',
        border: '1px solid #e5e7eb',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
        overflow: 'hidden',
    },
    listScroll: {
        maxHeight: '75vh',
        overflowY: 'auto',
    },
    listHeader: {
        display: 'grid',
        gridTemplateColumns: '1fr auto auto',
        alignItems: 'center',
        padding: '11px 20px',
        background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
        borderBottom: '2px solid #d1fae5',
        position: 'sticky',
        top: 0,
        zIndex: 5,
    },
    listHeaderCell: {
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
    },
    listRow: {
        display: 'grid',
        gridTemplateColumns: '1fr auto auto',
        alignItems: 'center',
        padding: '0 20px',
        borderBottom: '1px solid #f3f4f6',
        transition: 'background-color 0.15s ease',
        minHeight: '68px',
        gap: '16px',
    },
    listRowLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        minWidth: 0,
    },
    boardIconWrap: {
        width: '42px',
        height: '42px',
        borderRadius: '11px',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxShadow: '0 2px 8px rgba(26,125,62,0.22)',
    },
    boardNameWrap: {
        minWidth: 0,
    },
    boardName: {
        fontSize: '14px',
        fontWeight: '700',
        color: '#111827',
        margin: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    boardMeta: {
        fontSize: '12px',
        color: '#9ca3af',
        marginTop: '2px',
    },
    userPill: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '4px 12px',
        backgroundColor: '#f0fdf4',
        border: '1px solid #d1fae5',
        borderRadius: '20px',
        fontSize: '12.5px',
        fontWeight: '600',
        color: '#1a7d3e',
        whiteSpace: 'nowrap',
    },
    btnManage: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '5px',
        padding: '7px 16px',
        fontSize: '12.5px',
        fontWeight: '600',
        color: '#fff',
        backgroundColor: '#1a7d3e',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background-color 0.15s ease',
        boxShadow: '0 1px 4px rgba(26,125,62,0.25)',
        whiteSpace: 'nowrap',
    },

    /* ── Detail table view ── */
    tableCard: {
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    },
    tableScroll: {
        overflowX: 'auto',
        maxHeight: '72vh',
        overflowY: 'auto',
    },
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '13.5px',
    },
    theadRow: {
        background: 'linear-gradient(135deg, #f0fdf4 0%, #e8f5e9 100%)',
        borderBottom: '2px solid #d1fae5',
        position: 'sticky',
        top: 0,
        zIndex: 10,
    },
    th: {
        padding: '11px 16px',
        textAlign: 'left',
        fontSize: '11px',
        fontWeight: '700',
        color: '#1a7d3e',
        textTransform: 'uppercase',
        letterSpacing: '0.055em',
        whiteSpace: 'nowrap',
    },
    row: {
        backgroundColor: '#fff',
        borderBottom: '1px solid #f3f4f6',
        transition: 'background-color 0.15s ease',
    },
    indexCell: {
        padding: '12px 16px',
        color: '#9ca3af',
        fontWeight: '600',
        fontSize: '13px',
        verticalAlign: 'middle',
        width: '52px',
        textAlign: 'center',
    },
    td: {
        padding: '12px 16px',
        color: '#374151',
        fontSize: '13.5px',
        verticalAlign: 'middle',
    },
    userCell: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    avatar: {
        width: '34px',
        height: '34px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #1a7d3e 0%, #34a85a 100%)',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
    },
    userName: {
        fontWeight: '600',
        color: '#111827',
        fontSize: '13.5px',
    },
    userEmail: {
        fontSize: '12px',
        color: '#6b7280',
        marginTop: '1px',
    },
    columnBadgesWrap: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '6px',
    },
    columnBadge: {
        display: 'inline-block',
        padding: '3px 10px',
        backgroundColor: '#f0fdf4',
        border: '1px solid #d1fae5',
        borderRadius: '20px',
        fontSize: '11.5px',
        color: '#1a7d3e',
        fontWeight: '600',
    },
    noCols: {
        fontSize: '12.5px',
        color: '#9ca3af',
        fontStyle: 'italic',
    },
    btnDelete: {
        width: '32px',
        height: '32px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '7px',
        border: '1px solid #fee2e2',
        background: '#fff5f5',
        color: '#dc2626',
        cursor: 'pointer',
        transition: 'all 0.15s ease',
    },

    /* ── Loading / empty ── */
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '56px 0',
    },
    emptyText: {
        marginTop: '12px',
        fontSize: '14px',
        color: '#9ca3af',
        fontWeight: '500',
    },
    loaderWrap: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 0',
        gap: '12px',
    },
    spinner: {
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        border: '3px solid #dcfce7',
        borderTopColor: '#1a7d3e',
        animation: 'spin 0.8s linear infinite',
    },
    loaderText: {
        fontSize: '13px',
        color: '#9ca3af',
    },
};

const BoardAllocation = () => {
    const [boardData, setBoardData] = useState([]);
    const [selectedBoard, setSelectedBoard] = useState(null);
    const [boardUsers, setBoardUsers] = useState([]);
    const [loader, setLoader] = useState(false);
    const [detailLoader, setDetailLoader] = useState(false);

    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState(null);

    const navigate = useNavigate();

    const fetchBoardSummary = async () => {
        setLoader(true);
        try {
            const [boardsRes, assignmentsRes] = await Promise.all([
                services.board.GETALLBOARD(),
                services.userassignboard.GET_ALL_UserAssignBoard()
            ]);

            const allBoards = boardsRes?.data || [];
            const data = Array.isArray(assignmentsRes) ? assignmentsRes : (assignmentsRes?.data || []);

            const boardUserMap = data.reduce((acc, curr) => {
                const boardId = curr.boardId;
                const userId = curr.userId;
                if (!boardId || !userId) return acc;
                if (!acc[boardId]) acc[boardId] = new Set();
                acc[boardId].add(userId);
                return acc;
            }, {});

            const summary = allBoards.map(board => ({
                id: board.id,
                name: board.boardName,
                userCount: boardUserMap[board.id]?.size || 0
            })).sort((a, b) => b.userCount - a.userCount);

            setBoardData(summary);
        } catch (error) {
            console.error('Error fetching board summary:', error);
            toast.error('Failed to fetch board summary');
        } finally {
            setLoader(false);
        }
    };

    const fetchBoardDetails = async (board) => {
        setDetailLoader(true);
        setSelectedBoard(board);
        try {
            const response = await services.userassignboard.GET_ASSIGN_USER_BY_BOARD_ID(board.id, '', 'true');
            const data = response?.data?.data || [];

            const groupedUsers = data.reduce((acc, item) => {
                const userId = item.userId;
                const user = item.User;
                if (!userId) return acc;

                if (!acc[userId]) {
                    acc[userId] = {
                        userId,
                        name: user?.name || 'Unknown User',
                        email: user?.email || 'Unknown Email',
                        assignmentIds: [],
                        columns: new Set()
                    };
                }

                acc[userId].assignmentIds.push(item.id);

                try {
                    const parsed = typeof item.boardListId === 'string' ? JSON.parse(item.boardListId) : item.boardListId;
                    const columns = (Array.isArray(parsed) ? parsed : []).map(c => c.coloum || c.label).filter(Boolean);
                    columns.forEach(col => acc[userId].columns.add(col));
                } catch (e) { }

                return acc;
            }, {});

            const results = Object.values(groupedUsers).map(u => ({
                ...u,
                columns: Array.from(u.columns)
            }));

            setBoardUsers(results);
        } catch (error) {
            console.error('Error fetching board details:', error);
            toast.error('Failed to fetch user list for this board');
        } finally {
            setDetailLoader(false);
        }
    };

    const confirmDelete = (user) => {
        setDeleteInfo({ assignmentIds: user.assignmentIds, userName: user.name });
        setShowDeletePopup(true);
    };

    const handleDeleteAssignment = async () => {
        if (!deleteInfo) return;
        setShowDeletePopup(false);
        const { assignmentIds, userName } = deleteInfo;
        try {
            await Promise.all(assignmentIds.map(id => services.userassignboard.DELETE_UserAssignBoard(id)));
            toast.success(`${userName} removed from board successfully`);
            fetchBoardDetails(selectedBoard);
            fetchBoardSummary();
        } catch (error) {
            console.error('Error deleting assignment:', error);
            toast.error('Failed to remove user from board');
        } finally {
            setDeleteInfo(null);
        }
    };

    useEffect(() => {
        fetchBoardSummary();
    }, []);

    return (
        <div style={s.pageWrapper}>

            {/* ── Page Header ── */}
            <PageHeader
                onBack={() => selectedBoard ? setSelectedBoard(null) : navigate(-1)}
                icon={<FiLayout size={18} color="#fff" />}
                title={selectedBoard ? `Manage: ${selectedBoard.name}` : 'Board Allocation Management'}
                count={selectedBoard ? boardUsers.length : boardData.length}
            />

            {!selectedBoard ? (
                /* ── Board list ── */
                loader ? (
                    <div style={s.loaderWrap}>
                        <div style={s.spinner} />
                        <span style={s.loaderText}>Analyzing Board Allocations…</span>
                    </div>
                ) : boardData.length === 0 ? (
                    <div style={s.emptyState}>
                        <FiLayout size={40} color="#d1d5db" />
                        <p style={s.emptyText}>No boards found</p>
                    </div>
                ) : (
                    <div style={s.listCard}>
                        {/* List header */}
                        <div style={s.listHeader}>
                            <span style={s.listHeaderCell}>Board</span>
                            <span style={{ ...s.listHeaderCell, minWidth: '120px', textAlign: 'center' }}>Allocated Users</span>
                            <span style={{ ...s.listHeaderCell, minWidth: '110px', textAlign: 'right' }}>Action</span>
                        </div>

                        {/* List rows */}
                        <div style={s.listScroll}>
                            {boardData.map((board, index) => (
                                <div
                                    key={board.id}
                                    style={{
                                        ...s.listRow,
                                        borderBottom: index === boardData.length - 1 ? 'none' : '1px solid #f3f4f6',
                                    }}
                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f6fdf8'; }}
                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                                >
                                    {/* Board name + index */}
                                    <div style={s.listRowLeft}>
                                        <div style={s.boardIconWrap}>
                                            <FiLayout size={18} color="#fff" />
                                        </div>
                                        <div style={s.boardNameWrap}>
                                            <p style={s.boardName} title={board.name}>{board.name}</p>
                                            <p style={s.boardMeta}>Board #{index + 1}</p>
                                        </div>
                                    </div>

                                    {/* User count pill */}
                                    <div style={{ display: 'flex', justifyContent: 'center', minWidth: '120px' }}>
                                        <span style={s.userPill}>
                                            <FiUsers size={12} />
                                            {board.userCount} {board.userCount === 1 ? 'user' : 'users'}
                                        </span>
                                    </div>

                                    {/* Manage button */}
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', minWidth: '110px' }}>
                                        <button
                                            style={s.btnManage}
                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1a6b2e'; }}
                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#1a7d3e'; }}
                                            onClick={() => fetchBoardDetails(board)}
                                        >
                                            Manage
                                            <FiChevronRight size={13} />
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )
            ) : (
                /* ── Detail: users assigned to board ── */
                <div style={s.tableCard}>
                    <div style={s.tableScroll}>
                        <table style={s.table}>
                            <thead>
                                <tr style={s.theadRow}>
                                    <th style={{ ...s.th, textAlign: 'center', width: '52px' }}>#</th>
                                    <th style={s.th}>Assigned User</th>
                                    <th style={s.th}>Visible Columns</th>
                                    <th style={{ ...s.th, textAlign: 'center', width: '80px' }}>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {detailLoader ? (
                                    <tr>
                                        <td colSpan="4">
                                            <div style={s.loaderWrap}>
                                                <div style={s.spinner} />
                                                <span style={s.loaderText}>Fetching user list…</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : boardUsers.length === 0 ? (
                                    <tr>
                                        <td colSpan="4">
                                            <div style={s.emptyState}>
                                                <FiUsers size={38} color="#d1d5db" />
                                                <p style={s.emptyText}>No users assigned to this board yet</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    boardUsers.map((user, index) => (
                                        <tr
                                            key={user.userId}
                                            style={s.row}
                                            onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#f6fdf8'; }}
                                            onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff'; }}
                                        >
                                            <td style={s.indexCell}>{index + 1}</td>

                                            <td style={s.td}>
                                                <div style={s.userCell}>
                                                    <div style={s.avatar}>
                                                        {(user.name || '?').charAt(0).toUpperCase()}
                                                    </div>
                                                    <div>
                                                        <div style={s.userName}>{user.name}</div>
                                                        <div style={s.userEmail}>{user.email}</div>
                                                    </div>
                                                </div>
                                            </td>

                                            <td style={s.td}>
                                                {user.columns.length > 0 ? (
                                                    <div style={s.columnBadgesWrap}>
                                                        {user.columns.map((col, j) => (
                                                            <span key={j} style={s.columnBadge}>{col}</span>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <span style={s.noCols}>No specific columns</span>
                                                )}
                                            </td>

                                            <td style={{ ...s.td, textAlign: 'center' }}>
                                                <button
                                                    style={s.btnDelete}
                                                    title="Remove user from board"
                                                    onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#fee2e2'; e.currentTarget.style.borderColor = '#fca5a5'; }}
                                                    onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#fff5f5'; e.currentTarget.style.borderColor = '#fee2e2'; }}
                                                    onClick={() => confirmDelete(user)}
                                                >
                                                    <FiTrash2 size={14} />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            <DeletePopup
                open={showDeletePopup}
                title={`Remove ${deleteInfo?.userName} from board?`}
                description="This will delete all assignment records for this user on this specific board."
                onConfirm={handleDeleteAssignment}
                onCancel={() => {
                    setShowDeletePopup(false);
                    setDeleteInfo(null);
                }}
            />

            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );
};

export default BoardAllocation;
